export const GOOGLE_MAPS_API_KEY =
  String(process.env.NODE_ENV).toUpperCase() === 'PRODUCTION'
    ? 'AIzaSyCI3qSid1Q04ev8gjZppt5BF_VZRo3FUGk'
    : 'AIzaSyCIkf0IT3lgjAfv22-6Dx6hRhnBCRSIY2E'
export const CAPTCHA_SITE_KEY =
  String(process.env.NODE_ENV).toUpperCase() === 'PRODUCTION'
    ? '6LfFThYUAAAAAOMWuwswAT9GXSOpLX564H-zqags'
    : '6LdUTRYUAAAAANcs33Se2VJtbpiofYry4dMCyENJ'
export const RELEASE = '2.5'
export const SENTRY_URL = 'https://95a0afc8ae6344d4a5e2f81f44fd7c51@sentry.io/137626'



// WEBPACK FOOTER //
// ./src/constants/config.js